export default __webpack_public_path__ + "static/header-types-dark-921405ad64dff3da02ce5bfe41824a69.png";